export default __webpack_public_path__ + "static/media/placeholder.598166ee.svg";